<template>
  <el-input
      ref="gjInput"
      v-bind="$attrs"
      v-on="$listeners"
      :size="mapSize"
      :maxlength="maxlength"
      :style="{width}"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="{'gj-underline-input': underline,
        'gj-multi-check--search--input': multiCheckSearch,
        'gj-select--font14': font14,
        'gj-prefix-center': true,
        'gj-not-left-border': $slots.append,
        'gj-not-right-border': $slots.prepend,
        'gj-matching-input': isMatching()
        }"
      :clearable="clearable && isMeaningless($slots['suffix'])"
      @keydown.enter.native="handleEnter"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="$emit('input', $event)">
<!--    前置内容-->
    <template #prepend>
      <slot name="prepend"></slot>
    </template>
<!--    后置内容-->
    <template #append>
      <slot name="append"></slot>
    </template>
<!--    头部内容-->
    <template #prefix>
      <slot name="prefix"></slot>
    </template>
<!--    尾部内容-->
    <template #suffix>
      <slot name="suffix"></slot>
       <template v-if="isMatching()">
         <span :class="{'gj-matching__color': matching === 'like', 'gj-matching__text': true}" @click="matchingChange('like')">模糊 </span>|
         <span :class="{'gj-matching__color': matching === 'exact', 'gj-matching__text': true}" @click="matchingChange('exact')"> 精确</span>
       </template>
    </template>

  </el-input>
</template>
<script>
  import {sizeMap} from "../common";
  import {font14MixIn, isMeaninglessMixin} from "../../minxins";

  export default {
    name: "gj-input",
    mixins: [font14MixIn, isMeaninglessMixin],
    props: {
      width: {
        type: String,
        default: '100px',
      },
      size: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['default', 'mini', 'medium'].indexOf(value) !== -1
        }
      },
      placeholder: {
        type: String,
        default: '请输入',
      },
      underline: {
        type: Boolean,
        default: false
      },
      multiCheckSearch: {
        type: Boolean,
        default: false
      },
      circle: {
          type: Boolean,
          default: false,
      },
      circleSize: {
          type: String,
          default: '14px',
      },
      clearable: {
        type: Boolean,
        default: true
      },
      maxlength:{
        type:String,
      },
      disabled:{
        type: Boolean,
        default: false
      },
      isEnter: { // 回车事件
        type: Boolean,
        default: false
      },
      /*
        回车事件主要用于 app-filter-group 组件中进行搜索,也可以传入一个config
        ps：当前默认开启回车事件的组件有
            公共组件：
                gj-search-input
                gj-select-input
            业务中组件：
                gj-double-select-input
                app-neg-target-picker
      */
      enterConfig: {
        type: Object,
        default: () => {
          return {componentName: 'app-filter-group', eventName: 'handleQuery'}
        }
      },
      matching: {
        type: String,
        default: '',  // 模糊 like | 精确 exact
      }
    },
    data() {
      return {
        isFocus: false
      }
    },
    computed: {
      mapSize() {
         return sizeMap[this.size];
      }
    },
    mounted() {
        if (this.circle) {
            this.$refs && (this.$refs.gjInput.$refs.input.style.borderRadius = this.circleSize)
        }
    },
    methods: {
      focus () {
        return this.$refs.gjInput.focus()
      },
      handleFocus($event) {
        this.isFocus = true
      },
      handleBlur($event) {
        this.isFocus = false
      },
      // 回车事件
      handleEnter(){
        if (this.isEnter && this.isFocus) {
          const cb = this.findParentMethod(this.$parent, this.enterConfig.componentName)[this.enterConfig.eventName]
          cb && cb()
        }
      },
      // 向上查找实例
      findParentMethod(instance, componentName) {
        if (!instance) return
        //普通组件
        if (instance.$options._componentTag && instance.$options._componentTag === componentName) {
            return instance
        }
        //create创建的modal等
        if (instance.$vnode.data.name && instance.$vnode.data.name === componentName) {
          return instance
        }
        instance = instance.$parent
        return this.findParentMethod(instance, componentName)
      },
      isMatching() {
        return !this.isMeaningless(this.matching);
      },
      matchingChange(event) {
        this.$emit('update:matching', event);
        this.$emit('matchingChange', event);
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-input-group__append,
  /deep/ .el-input-group__prepend {
    padding: 0 12px;
  }
  .gj-underline-input{
    margin-top: 6px;
  }
  .gj-underline-input /deep/ input  {
    padding: 0 5px;
  }
  .gj-multi-check--search--input /deep/ input  {
    padding: 4px 8px;
  }
  .gj-select--font14 /deep/ .el-input__inner,
  .gj-select--font14 /deep/ .el-input-group__prepend {
    font-size: 14px;
  }

  /*!*前置*!*/
  /deep/ .el-input-group__prepend {
    box-sizing: border-box;
    color: #666666;
    background: #EEEFF0;
    min-width: 30px;
    /*padding: 5px;*/
    text-align: center;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }
  /*后置*/
  /deep/ .el-input-group__append {
    box-sizing: border-box;
    color: #666666;
    background: #EEEFF0;
    min-width: 30px;
    padding: 5px;
    text-align: center;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
  /*头部*/
  /deep/ .el-input__prefix {
    position: absolute;
    height: 100%;
    left: 5px;
    top: 0;
    text-align: center;
    color: #C0C4CC;
    transition: all .3s;
    display: grid;
    align-items: center;
  }
  .gj-matching-input{
    /deep/ .el-input__clear{
      position: absolute;
      left:-30px;
      top:0;
    }
    /deep/ .el-input__inner{
      padding-right: 90px;
    }
    /deep/ .el-input-group__prepend{
      .el-input__inner{
        padding-right: 0;
      }
    }
    /deep/ .el-input__suffix-inner{
      color: #999999;
    }
    /deep/ .el-input__suffix{
      top: -1px
    }
  }
  .gj-matching__color {
    color: #1F6EEF;
  }
  .gj-matching__text{
    cursor: pointer;
    &:hover{
      color: #1F6EEF;
    }
  }
  /*尾部*/
  // .gj-not-left-border{
  //   /deep/ .el-input__inner{
  //     border-right-color: #EEEFF0;
  //     &:hover, &:focus{
  //      border-right-color: #1F6EEF;
  //     }
  //   }
  // }
  // .gj-not-right-border{
  //   /deep/ .el-input__inner{
  //     border-left-color: #EEEFF0;
  //     &:hover, &:focus{
  //      border-left-color: #1F6EEF;
  //     }
  //   }
  // }
  // .gj-not-right-border.el-form-item.is-error{

  // }
</style>
